import React from "react";
import { Img } from "../../../components/img";
import '../css/second-block.css'


export const SecondBlock=()=>{
    return(
        <div className="div2">
            <div className='div2_center'>
                <div className='imgController'>
                    <Img imgPath="Group3.png" height="100%" width="100%"/>
                </div>
                <div className='imgController mt-4'>
                    <Img imgPath="Group 4.png" height="100%" width="100%"/>
                </div>
                <div className='div2-action d-flex align-items-center justify-content-between mt-3'>
                    <p>Акція діє тільки в мережі магазинів</p>
                    <div className=' d-flex align-items-center justify-content-between'>
                        <div className="mx-2" style={{width:`28px`,height:`37px`}}>
                            <Img imgPath="NR.png" height="100%" width="100%"/>
                        </div>
                        <div className="mx-2" style={{width:`125px`,height:`25px`}}>
                            <Img imgPath="Main - Horizontal Color.png" height="100%" width="100%"/>
                        </div>
                    </div>                
                </div>
            </div>
            
        </div>
    )
}